var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftwareDevelopment13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 46.2,
    r: 46.2,
    fill: "#FFEBC8",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFA200",
    fillRule: "nonzero",
    stroke: "#FFA200",
    strokeWidth: 0.525
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.42 3.433h-1.84V.675c0-.263-.197-.525-.525-.525H24.411c-1.445 0-2.693.788-3.35 1.97C20.406.938 19.158.15 17.714.15H3.003c-.263 0-.526.197-.526.525v2.693H.704c-.262 0-.525.197-.525.525v26.465c0 .262.197.525.525.525H41.42c.263 0 .525-.197.525-.525V3.893c0-.263-.262-.46-.525-.46zM24.41 1.201h14.251V27.6h-15.3c-.658 0-1.38.262-1.774.656V4.024 3.96c.328-1.97 1.38-2.758 2.824-2.758zm-20.882 0h14.25c1.38 0 2.561.788 2.824 2.823h0v24.167c-.46-.394-1.116-.657-1.773-.657H3.528V1.2zM1.23 4.418h1.313V28.06c0 .263.197.526.525.526h15.76c.723 0 1.446.46 1.708 1.313H1.23V4.418zm39.73 25.414H21.652c.262-.788.985-1.313 1.707-1.313h15.76c.263 0 .526-.197.526-.525V4.353h1.313v25.48z",
    transform: "translate(25.5 30.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.614 4.615H17.384V5.615H6.614zM6.614 9.278H17.384V10.278H6.614zM6.614 14.006H17.384V15.006H6.614zM6.614 18.669H17.384V19.669H6.614zM6.614 23.331H17.384V24.331H6.614zM24.673 4.615H35.443V5.615H24.673zM24.673 9.278H35.443V10.278H24.673zM24.673 14.006H35.443V15.006H24.673zM24.673 18.669H35.443V19.669H24.673zM24.673 23.331H35.443V24.331H24.673z",
    transform: "translate(25.5 30.7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDevelopment13);
export default __webpack_public_path__ + "static/media/software-development13.80c2c2d2a0a288d53e7a82022ea79bc7.svg";
export { ForwardRef as ReactComponent };